import { useCurrentRoute, useOfficeComponentContext, } from '@office-start/component-context-service';
import { useMatchMedia } from '@office-start/dom-utility';
import { useFeatureGates } from '@office-start/feature-gates-service';
import { useIdentity } from '@office-start/identity-service';
import { useShellTheme, useThemeId, useThemeMode, } from '@office-start/theming-service';
import { useMemo } from 'react';
import { getRouteFlight } from '../util/getRouteFlight';
import { isVisualBackgroundEnabled } from '../util/isVisualBackgroundEnabled';
export var useVisualBackgroundEnabled = function () {
    // $TODO: Integrate useHarmonyTheme instead of useThemeMode and useThemeId
    var themeMode = useThemeMode();
    var themeId = useThemeId();
    var identity = useIdentity().data;
    var currentRoute = useCurrentRoute();
    var isHighContrast = useMatchMedia('(-ms-high-contrast: active)');
    var isForcedColors = useMatchMedia('(forced-colors: active)');
    var shellTheme = useShellTheme();
    var componentContext = useOfficeComponentContext().data;
    var featureGates = useFeatureGates().data;
    return useMemo(function () {
        if (!currentRoute ||
            !featureGates ||
            !featureGates.result.visualGates ||
            !identity ||
            isForcedColors === undefined ||
            isHighContrast === undefined ||
            !themeMode ||
            !themeId ||
            !componentContext ||
            (!componentContext.inMockMode &&
                !identity.isMsa &&
                componentContext.workload == 'officehomereact' &&
                !shellTheme)) {
            return undefined;
        }
        return isVisualBackgroundEnabled(identity.isMsa, isHighContrast || isForcedColors, getRouteFlight(currentRoute.route), themeId, themeMode, featureGates.result.visualGates);
    }, [
        currentRoute,
        featureGates,
        identity,
        isForcedColors,
        isHighContrast,
        themeMode,
        themeId,
        componentContext,
        shellTheme,
    ]);
};
//# sourceMappingURL=useVisualBackgroundEnabled.js.map